import Checkbox from "../../../utils/components/Checkbox";

const CheckboxLayout = ({ items, isVertical, disabled, onChange }) => {
  const handleChange = (index) => {
    if (disabled) return;

    const newItems = [...items];

    newItems[index].checked = !newItems[index].checked;

    onChange(newItems.filter((item) => item.checked));
  };

  return (
    <div
      className={`d-flex w-100 ${
        isVertical ? `flex-column align-items-start` : `justify-content-between`
      }`}
    >
      {items.map((item, index) => (
        <Checkbox
          key={index}
          disabled={disabled}
          label={item.label}
          checked={item.checked}
          onChange={() => handleChange(index)}
        />
      ))}
    </div>
  );
};
export default CheckboxLayout;
